import { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import VLSlider from "views/uikit/VLSlider";

export interface ThresholdInputProps {
  title: string;
  value: number;
  step?: number;
  range?: number[];
  onChange: (value: number) => void;
}

export default function ThresholdInput({
  step = 1,
  title,
  value,
  range,
  onChange,
}: ThresholdInputProps) {
  const withoutRange = !range;

  const initialCurrentValue = withoutRange
    ? value
    : range.indexOf(value) > -1
      ? range.indexOf(value)
      : range.length - 1;

  const [currentValue, setCurrentValue] = useState(initialCurrentValue);
  useEffect(() => {
    setCurrentValue(initialCurrentValue);
  }, [initialCurrentValue]);

  const min = 0;
  const max = withoutRange ? 1 : range.length - 1;
  const selectedValue = withoutRange ? currentValue : range[currentValue];

  const tooltipFormatter = useCallback(
    (v?: number) => {
      if (v === undefined) {
        return String(selectedValue);
      }
      return String(withoutRange ? v : range[v]);
    },
    [withoutRange, range, selectedValue],
  );

  const handleChangeComplete = useCallback(
    (v: number | number[]) => {
      const num = v as number;
      const resolved = withoutRange ? num : range[num];
      onChange(resolved);
    },
    [withoutRange, range, onChange],
  );

  return (
    <div
      className={classNames(styles.rangeContainer, "rangeContainer")}
      data-testid="threshold-slider-container"
    >
      <div className={classNames(styles.title, "rangeTitle")}>{title}</div>
      <div className={classNames(styles.label, "rangeLabel")}>Low</div>
      <div className={styles.inputContainer}>
        <div className={styles.sliderWrapper}>
          <VLSlider
            min={min}
            max={max}
            step={withoutRange ? step : 1}
            value={currentValue}
            onChange={(v) => setCurrentValue(v as number)}
            onChangeComplete={handleChangeComplete}
            className={styles.slider}
            tooltip={{
              open: true,
              formatter: tooltipFormatter,
            }}
          />
        </div>

        {range ? (
          <div className={styles.ticks}>
            {range.map((_, index) => (
              <div key={index} className={styles.tick}></div>
            ))}
          </div>
        ) : null}
      </div>
      <div className={styles.label}>High</div>
    </div>
  );
}
